module.exports = __webpack_public_path__ + "static/media/index.7533641a.ts";


//////////////////
// WEBPACK FOOTER
// ../servidor/protocolo/index.ts
// module id = 779
// module chunks = 0